export default __webpack_public_path__ + "static/media/menu.de21b81a.svg";